import clsx from 'clsx';

import { Icon } from '../icon';

import './shortcut.scss';

export const Shortcut = (props: ShortcutProps) => {
  const { data, className, size = 'default', appearance = 'default' } = props;

  const iconsMap: Record<string, string> = {
    Alt: 'key-option',
    Space: 'key-spacebar',
    Shift: 'key-shift',
    Control: 'command',
    Backspace: 'eraser-01',
    backspace: 'eraser-01',
    ControlOrCommand: 'command',
    CommandOrControl: 'command',
    Enter: 'arrow-turn-backward-shortcut',
  };

  return (
    <div
      className={clsx('shortcut-holder', `s-${size}`, `a-${appearance}`, className, {
        'has-shortcut': !!data,
      })}
      data-testid="shortcut"
    >
      {!data ? (
        <span>Set shortcut</span>
      ) : (
        <>
          {data.split('+').map((key) =>
            iconsMap[key] ? (
              <Icon key={key} size={12} type={iconsMap[key]} />
            ) : (
              <span className="shortcut-key" key={key}>
                {key}
              </span>
            )
          )}
        </>
      )}
    </div>
  );
};

interface ShortcutProps {
  data?: string;
  className?: string;
  size?: 'small' | 'default';
  appearance?: 'default' | 'greyscale' | 'light';
}
